<h1 mat-dialog-title>Are you sure you want to delete this note?</h1>
<div mat-dialog-actions align="center" class="tw-gap-2">
    <button mat-button class="tw-text-base" (click)="onYesClick()">Yes</button>
    <button mat-button class="tw-text-base" (click)="onNoClick()">No</button>
</div>
